var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 41,
    viewBox: "0 0 135 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 135,
    height: 40,
    rx: 5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.137 22.2509C65.785 22.2509 63.868 24.0399 63.868 26.5039C63.868 28.9529 65.785 30.7569 68.137 30.7569C70.49 30.7569 72.407 28.9529 72.407 26.5039C72.406 24.0399 70.489 22.2509 68.137 22.2509ZM68.137 29.0829C66.848 29.0829 65.737 28.0199 65.737 26.5049C65.737 24.9739 66.849 23.9269 68.137 23.9269C69.426 23.9269 70.537 24.9739 70.537 26.5049C70.537 28.0189 69.426 29.0829 68.137 29.0829ZM58.823 22.2509C56.471 22.2509 54.554 24.0399 54.554 26.5039C54.554 28.9529 56.471 30.7569 58.823 30.7569C61.176 30.7569 63.093 28.9529 63.093 26.5039C63.093 24.0399 61.176 22.2509 58.823 22.2509ZM58.823 29.0829C57.534 29.0829 56.423 28.0199 56.423 26.5049C56.423 24.9739 57.535 23.9269 58.823 23.9269C60.112 23.9269 61.223 24.9739 61.223 26.5049C61.224 28.0189 60.112 29.0829 58.823 29.0829ZM47.745 23.5569V25.3609H52.063C51.934 26.3759 51.596 27.1169 51.08 27.6319C50.452 28.2599 49.469 28.9529 47.745 28.9529C45.087 28.9529 43.009 26.8099 43.009 24.1519C43.009 21.4939 45.087 19.3509 47.745 19.3509C49.179 19.3509 50.226 19.9149 50.999 20.6399L52.272 19.3669C51.192 18.3359 49.759 17.5469 47.745 17.5469C44.104 17.5469 41.043 20.5109 41.043 24.1519C41.043 27.7929 44.104 30.7569 47.745 30.7569C49.71 30.7569 51.193 30.1119 52.352 28.9039C53.544 27.7119 53.915 26.0359 53.915 24.6829C53.915 24.2649 53.883 23.8779 53.818 23.5559H47.745V23.5569ZM93.053 24.9579C92.699 24.0079 91.619 22.2509 89.412 22.2509C87.221 22.2509 85.4 23.9749 85.4 26.5039C85.4 28.8879 87.205 30.7569 89.621 30.7569C91.57 30.7569 92.698 29.5649 93.166 28.8719L91.716 27.9049C91.233 28.6139 90.572 29.0809 89.621 29.0809C88.671 29.0809 87.994 28.6459 87.559 27.7919L93.246 25.4399L93.053 24.9579ZM87.253 26.3759C87.205 24.7319 88.526 23.8949 89.477 23.8949C90.218 23.8949 90.846 24.2659 91.056 24.7969L87.253 26.3759ZM82.63 30.4999H84.498V17.9989H82.63V30.4999ZM79.568 23.2019H79.504C79.085 22.7019 78.279 22.2509 77.265 22.2509C75.138 22.2509 73.189 24.1199 73.189 26.5209C73.189 28.9049 75.138 30.7579 77.265 30.7579C78.28 30.7579 79.085 30.3069 79.504 29.7919H79.568V30.4039C79.568 32.0309 78.698 32.9009 77.297 32.9009C76.153 32.9009 75.444 32.0799 75.154 31.3869L73.527 32.0639C73.994 33.1909 75.234 34.5769 77.297 34.5769C79.488 34.5769 81.341 33.2879 81.341 30.1459V22.5099H79.569V23.2019H79.568ZM77.426 29.0829C76.137 29.0829 75.058 28.0029 75.058 26.5209C75.058 25.0219 76.137 23.9269 77.426 23.9269C78.698 23.9269 79.697 25.0219 79.697 26.5209C79.697 28.0029 78.698 29.0829 77.426 29.0829ZM101.807 17.9989H97.336V30.4999H99.201V25.7639H101.806C103.874 25.7639 105.908 24.2669 105.908 21.8819C105.908 19.4969 103.875 17.9989 101.807 17.9989ZM101.855 24.0239H99.201V19.7389H101.855C103.25 19.7389 104.042 20.8939 104.042 21.8819C104.042 22.8499 103.25 24.0239 101.855 24.0239ZM113.387 22.2289C112.036 22.2289 110.637 22.8239 110.058 24.1429L111.714 24.8339C112.068 24.1429 112.728 23.9169 113.419 23.9169C114.384 23.9169 115.365 24.4959 115.381 25.5249V25.6539C115.043 25.4609 114.319 25.1719 113.435 25.1719C111.65 25.1719 109.832 26.1529 109.832 27.9859C109.832 29.6589 111.296 30.7359 112.936 30.7359C114.19 30.7359 114.882 30.1729 115.316 29.5129H115.38V30.4779H117.182V25.6849C117.183 23.4669 115.525 22.2289 113.387 22.2289ZM113.161 29.0799C112.551 29.0799 111.698 28.7739 111.698 28.0179C111.698 27.0529 112.76 26.6829 113.677 26.6829C114.496 26.6829 114.883 26.8599 115.381 27.1009C115.236 28.2599 114.239 29.0799 113.161 29.0799ZM123.744 22.5019L121.605 27.9219H121.541L119.321 22.5019H117.311L120.64 30.0769L118.742 34.2909H120.688L125.819 22.5019H123.744ZM106.938 30.4999H108.803V17.9989H106.938V30.4999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4176 10.7432C47.4176 11.5812 47.1696 12.2482 46.6726 12.7462C46.1086 13.3382 45.3726 13.6342 44.4686 13.6342C43.6026 13.6342 42.8656 13.3342 42.2606 12.7342C41.6546 12.1332 41.3516 11.3892 41.3516 10.5012C41.3516 9.61219 41.6546 8.86819 42.2606 8.26819C42.8656 7.66719 43.6026 7.36719 44.4686 7.36719C44.8986 7.36719 45.3096 7.45119 45.6996 7.61819C46.0906 7.78619 46.4036 8.00919 46.6376 8.28819L46.1106 8.81619C45.7136 8.34119 45.1666 8.10419 44.4676 8.10419C43.8356 8.10419 43.2896 8.32619 42.8286 8.77019C42.3676 9.21419 42.1376 9.79119 42.1376 10.5002C42.1376 11.2092 42.3676 11.7862 42.8286 12.2302C43.2896 12.6742 43.8356 12.8962 44.4676 12.8962C45.1376 12.8962 45.6966 12.6732 46.1436 12.2262C46.4336 11.9352 46.6016 11.5302 46.6466 11.0112H44.4676V10.2902H47.3746C47.4046 10.4472 47.4176 10.5982 47.4176 10.7432Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0277 8.23724H49.2957V10.1392H51.7597V10.8602H49.2957V12.7622H52.0277V13.5002H48.5247V7.50024H52.0277V8.23724Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2785 13.5002H54.5075V8.23724H52.8315V7.50024H56.9545V8.23724H55.2785V13.5002Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9375 13.5002V7.50024H60.7085V13.5002H59.9375Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1277 13.5002H63.3567V8.23724H61.6807V7.50024H65.8037V8.23724H64.1277V13.5002Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6084 12.7252C73.0184 13.3312 72.2854 13.6342 71.4084 13.6342C70.5314 13.6342 69.7984 13.3312 69.2094 12.7252C68.6194 12.1192 68.3254 11.3772 68.3254 10.5002C68.3254 9.62323 68.6194 8.88123 69.2094 8.27523C69.7984 7.66923 70.5314 7.36523 71.4084 7.36523C72.2804 7.36523 73.0124 7.67023 73.6044 8.27923C74.1964 8.88823 74.4924 9.62823 74.4924 10.5002C74.4924 11.3772 74.1974 12.1192 73.6084 12.7252ZM69.7784 12.2222C70.2224 12.6722 70.7654 12.8962 71.4084 12.8962C72.0514 12.8962 72.5954 12.6712 73.0384 12.2222C73.4824 11.7722 73.7054 11.1982 73.7054 10.5002C73.7054 9.80223 73.4824 9.22823 73.0384 8.77823C72.5954 8.32823 72.0514 8.10423 71.4084 8.10423C70.7654 8.10423 70.2224 8.32923 69.7784 8.77823C69.3354 9.22823 69.1124 9.80223 69.1124 10.5002C69.1124 11.1982 69.3354 11.7722 69.7784 12.2222Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5745 13.5002V7.50024H76.5125L79.4285 12.1672H79.4615L79.4285 11.0112V7.50024H80.1995V13.5002H79.3945L76.3435 8.60625H76.3105L76.3435 9.76224V13.5002H75.5745Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4176 10.7432C47.4176 11.5812 47.1696 12.2482 46.6726 12.7462C46.1086 13.3382 45.3726 13.6342 44.4686 13.6342C43.6026 13.6342 42.8656 13.3342 42.2606 12.7342C41.6546 12.1332 41.3516 11.3892 41.3516 10.5012C41.3516 9.61219 41.6546 8.86819 42.2606 8.26819C42.8656 7.66719 43.6026 7.36719 44.4686 7.36719C44.8986 7.36719 45.3096 7.45119 45.6996 7.61819C46.0906 7.78619 46.4036 8.00919 46.6376 8.28819L46.1106 8.81619C45.7136 8.34119 45.1666 8.10419 44.4676 8.10419C43.8356 8.10419 43.2896 8.32619 42.8286 8.77019C42.3676 9.21419 42.1376 9.79119 42.1376 10.5002C42.1376 11.2092 42.3676 11.7862 42.8286 12.2302C43.2896 12.6742 43.8356 12.8962 44.4676 12.8962C45.1376 12.8962 45.6966 12.6732 46.1436 12.2262C46.4336 11.9352 46.6016 11.5302 46.6466 11.0112H44.4676V10.2902H47.3746C47.4046 10.4472 47.4176 10.5982 47.4176 10.7432Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0277 8.23724H49.2957V10.1392H51.7597V10.8602H49.2957V12.7622H52.0277V13.5002H48.5247V7.50024H52.0277V8.23724Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2785 13.5002H54.5075V8.23724H52.8315V7.50024H56.9545V8.23724H55.2785V13.5002Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9375 13.5002V7.50024H60.7085V13.5002H59.9375Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1277 13.5002H63.3567V8.23724H61.6807V7.50024H65.8037V8.23724H64.1277V13.5002Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6084 12.7252C73.0184 13.3312 72.2854 13.6342 71.4084 13.6342C70.5314 13.6342 69.7984 13.3312 69.2094 12.7252C68.6194 12.1192 68.3254 11.3772 68.3254 10.5002C68.3254 9.62323 68.6194 8.88123 69.2094 8.27523C69.7984 7.66923 70.5314 7.36523 71.4084 7.36523C72.2804 7.36523 73.0124 7.67023 73.6044 8.27923C74.1964 8.88823 74.4924 9.62823 74.4924 10.5002C74.4924 11.3772 74.1974 12.1192 73.6084 12.7252ZM69.7784 12.2222C70.2224 12.6722 70.7654 12.8962 71.4084 12.8962C72.0514 12.8962 72.5954 12.6712 73.0384 12.2222C73.4824 11.7722 73.7054 11.1982 73.7054 10.5002C73.7054 9.80223 73.4824 9.22823 73.0384 8.77823C72.5954 8.32823 72.0514 8.10423 71.4084 8.10423C70.7654 8.10423 70.2224 8.32923 69.7784 8.77823C69.3354 9.22823 69.1124 9.80223 69.1124 10.5002C69.1124 11.1982 69.3354 11.7722 69.7784 12.2222Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5745 13.5002V7.50024H76.5125L79.4285 12.1672H79.4615L79.4285 11.0112V7.50024H80.1995V13.5002H79.3945L76.3435 8.60625H76.3105L76.3435 9.76224V13.5002H75.5745Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_5874_58996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4357 8.03784C10.1447 8.34584 9.97266 8.82384 9.97266 9.44284V31.5588C9.97266 32.1788 10.1447 32.6558 10.4357 32.9638L10.5097 33.0358L22.8987 20.6468V20.5008V20.3548L10.5097 7.96484L10.4357 8.03784Z",
    fill: "url(#paint0_linear_5874_58996)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0274 24.7776L22.8984 20.6466V20.5006V20.3546L27.0284 16.2246L27.1214 16.2776L32.0144 19.0576C33.4114 19.8516 33.4114 21.1506 32.0144 21.9456L27.1214 24.7256L27.0274 24.7776Z",
    fill: "url(#paint1_linear_5874_58996)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_5874_58996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1235 24.725L22.8995 20.501L10.4375 32.964C10.8975 33.452 11.6585 33.512 12.5155 33.026L27.1235 24.725Z",
    fill: "url(#paint2_linear_5874_58996)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.1235 16.2767L12.5155 7.9767C11.6585 7.4897 10.8975 7.5507 10.4375 8.0387L22.9005 20.5017L27.1235 16.2767Z",
    fill: "url(#paint3_linear_5874_58996)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_5874_58996",
    x: 9.97266,
    y: 7.64062,
    width: 23.0898,
    height: 25.7207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5874_58996"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_5874_58996",
    result: "effect2_innerShadow_5874_58996"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_5874_58996",
    x: 10.4375,
    y: 20.501,
    width: 16.6875,
    height: 12.8604,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5874_58996"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5874_58996",
    x1: 21.8005,
    y1: 9.20884,
    x2: 5.01846,
    y2: 25.9908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5874_58996",
    x1: 33.8329,
    y1: 20.5006,
    x2: 9.63704,
    y2: 20.5006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5874_58996",
    x1: 24.8296,
    y1: 22.7949,
    x2: 2.0711,
    y2: 45.5534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5874_58996",
    x1: 7.2989,
    y1: 0.676501,
    x2: 17.4612,
    y2: 10.8388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.e46121dd67a9473bf91d4d4e16cef000.svg";
export { ForwardRef as ReactComponent };